import React from "react";
import { connect } from "react-redux";
import { IntlProvider } from "react-intl";

const LanguageWrapper = ({ updateParticipantResp, children, messages, defaultLanguage }) => {
  let language = defaultLanguage;

  if (updateParticipantResp &&updateParticipantResp.handleHoldLedgerFrenchRedirect) {
    language = "fr";
  }

  return (
    <IntlProvider locale={language} messages={messages[language]}>
      {children}
    </IntlProvider>
  );
};

const mapStateToProps = (state) => ({
  updateParticipantResp: state.successStore.updateParticipantResp
});

export default connect(mapStateToProps)(LanguageWrapper);
